import Dinero from 'dinero.js';

export default function amount(value) {
  if (!value) return '';

  const amount = Dinero(value);
  const unit = amount.toUnit();
  const currency = amount.getCurrency();
  return new Intl.NumberFormat('de-CH', { style: 'currency', currency }).format(
    unit
  );
}
